module.exports = __webpack_public_path__ + "img/prevent-2-pic.5a9f393b.jpg";